import React from 'react'
import ImageModal from '@/apps/ImageModal'
import { family } from '@/images'

const Family = (): React.ReactElement => {
  return <ImageModal title='Семья Лазаревых' src={family} />
}

export default Family
